import { configureStore } from '@reduxjs/toolkit';
// import PhotoReducer from 'components/photo_selector/PhotosSlice.js'
import CollageConfigReducer from 'components/collage/CollageSlice.js'

export default configureStore({
  reducer: {
    // photos: PhotoReducer,
    collage: CollageConfigReducer
  },
});
